export type NavOptionsInt =
  | typeof ACCUEIL
  | typeof SOCIÉTÉ
  | typeof CATALOGUE
  | typeof EXPERTISE
export const ACCUEIL: string = 'ACCUEIL';
export const SOCIÉTÉ: string = 'SOCIÉTÉ';
export const CATALOGUE: string = 'CATALOGUE ';
export const EXPERTISE: string = 'EXPERTISE ';
export const NAV_OPTIONS = [ACCUEIL, SOCIÉTÉ, CATALOGUE, EXPERTISE];
